import React from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../../../constants/aampeTheme';

interface SummaryItemProps {
    label: string;
    value: React.ReactNode;
    subValue?: React.ReactNode;
    children?: React.ReactNode;
}

const Wrapper = styled.div({
    marginBottom: aampeTheme.spacing4(8),
    gap: aampeTheme.spacing4(1),
    display: 'flex',
    flexDirection: 'column',
});

const Label = styled.div({
    fontSize: aampeTheme.size.font.textMedium,
    color: aampeTheme.colors.textAccessibleWG01,
    fontWeight: aampeTheme.weights.light,
    lineHeight: aampeTheme.size.lineHeight.small,
});

const Value = styled.div({
    fontWeight: aampeTheme.weights.heavy,
    color: aampeTheme.colors.neutral09,
    lineHeight: aampeTheme.size.lineHeight.small,
    fontSize: aampeTheme.size.font.textMedium,
});

export const SummaryItem: React.FC<SummaryItemProps> = ({
    label,
    value,
    subValue,
}) => (
    <Wrapper>
        <Label>{label}</Label>
        <Value>{value}</Value>
        {subValue && subValue}
    </Wrapper>
);
